import React from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import Button from '@material-ui/core/Button'

const ConfirmDialog = ({
  isOpen = false,
  onClose,
  title = 'Confirm Action',
  contentText = '',
  onAgree,
  onDisagree,
  leftButtonLable = 'Disagree',
  rightButtonLable = 'Agree',
}) => (
  <Dialog open={isOpen} onClose={onClose} disableEnforceFocus={true}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <DialogContentText>{contentText}</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onDisagree} color="primary">
        {leftButtonLable}
      </Button>
      <Button onClick={onAgree} color="primary" autoFocus>
        {rightButtonLable}
      </Button>
    </DialogActions>
  </Dialog>
)
export default ConfirmDialog



// WEBPACK FOOTER //
// ./src/Components/ConfirmDialog/ConfirmDialog.js